<template>
  <form v-if="!loading" class="nameform m-center" @submit="submit">
    <div v-if="validCertificate === false" class="content flex flex-wrap">
      <h1 class="mb-6" style="margin: 0 auto 15px;">Leggi attentamente</h1>
      <div class="w-full">
        <p class="f-b mb-2">
          Io sottoscritto
        </p>
        <p class="text-grey mb-3">
          confermo la congruità ed esattezza dei dati anagrafici rilasciati e
          inseriti nella Richiesta di attivazione di cui ha preso visione,
          consapevole che chiunque renda dichiarazioni mendaci è punibile ai
          sensi del codice penale e delle leggi speciali in materia (cfr. DPR
          445/2000);
        </p>
        <p class="text-grey mb-3">
          richiedo ad InfoCert S.p.A. il rilascio di un Certificato qualificato
          alle condizioni indicate nel Contratto, di cui ha preso visione
          effettuando il download;
        </p>
        <p class="text-grey mb-3">
          prendo atto che il contratto relativo al Servizio FD è sospensivamente
          condizionato al buon esito dell'identificazione;
        </p>
        <p class="text-grey mb-3">
          prendo atto che il Service Provider potrà richiedere ad InfoCert di
          sospendere o revocare il sopra menzionato Certificato Qualificato,
          secondo quanto previsto dalla documentazione InfoCert e, in ogni caso,
          qualora il Titolare non sia più legato al Service Provider da alcun
          rapporto contrattuale;
        </p>
        <p class="text-grey mb-3">
          dichiara di essere informato che, in caso di stipulazione a distanza
          del contratto relativo al Servizio FD, può recedere dal Contratto
          entro il termine di 14 giorni lavorativi a decorrere dalla data della
          conclusione dello stesso, senza alcuna penalità e senza specificarne
          il motivo con le modalità stabilite dalle Condizioni Generali.
        </p>
      </div>
    </div>

    <div v-if="validCertificate === false" class="page-footer mt-5">
      <button class="btn" type="submit" :disabled="loading">
        Si, richiedi il certificato
      </button>
    </div>
  </form>
  <SignatureLoader
    title="Stiamo preparando i tuoi documenti, richiederà circa 1 minuto"
    :steps="[
      'Verifica documento di identità',
      'Creazione documenti',
      'Compilazione documenti digitali'
    ]"
    v-else
    :loadingLevel="loadingLevel"
  />
</template>

<script>
import RegistrationService from "@/services/RegistrationService";
import UtilityService from "@/services/UtilityService";
import DocumentsService from "@/services/DocumentsService";
import SignatureLoader from "@/modules/SignatureLoader";

export default {
  name: "RequestCertificate",
  components: {
    SignatureLoader
  },

  data() {
    return {
      loading: false,
      loadingLevel: 0,
      validCertificate: null
    };
  },

  mounted() {
    this.$root.$emit("openGlobalLoader");
    RegistrationService.userHasValidCertificate().then(
      validCertificate => {
        this.validCertificate = validCertificate;
        this.$root.$emit("closeGlobalLoader");
        if (validCertificate) {
          this.submit();
        }
      },
      error => {
        UtilityService.showDefaultError(error);
      }
    );
  },
  methods: {
    async submit() {
      //prevent form submit
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      this.loadingLevel = 0;

      setTimeout(() => {
        const $pageElement = document.querySelector(".page");
        $pageElement.scrollTop = 0;
      }, 100);

      setTimeout(() => {
        this.loadingLevel = 1;
      }, 2000);

      setTimeout(() => {
        this.loadingLevel = 2;
      }, 7000);

      try {
        const { data: dossier } = await RegistrationService.createDossier({
          mode: "NA"
        });
        const { data: startDossier } = await RegistrationService.startDossier(
          dossier
        );

        const infocertData = {
          ...dossier,
          acceptedClauses: startDossier.clauses.map(c => c.id)
        };

        if (this.validCertificate === false) {
          const {
            data: signData
          } = await RegistrationService.signAndAssertAuth(dossier);

          await RegistrationService.getInforcertTerms();

          infocertData.transactionId = signData.id;

          const { data: clauses } = await RegistrationService.acceptClauses(
            infocertData
          );

          this.$store.commit("setUser", {
            clauses: clauses.documents.map(d => {
              return { id: d.id, acceptedTerms: d.signatures.map(s => s.id) };
            })
          });
        } else {
          infocertData.valid = true;
          await DocumentsService.getMyContracts().then(response => {
            let c = response.contracts.filter(doc => doc.documentId === "ID3");
            this.$store.commit("setUser", {
              clauses: c.map(d => {
                return {
                  id: d.documentId,
                  acceptedTerms: d.signs.map(s => s.signId)
                };
              })
            });
          });
        }

        this.$store.commit("setUser", {
          infocert: infocertData
        });

        await RegistrationService.upgradeRegistrationProgress(3);
        this.loadingLevel = 3;

        setTimeout(() => {
          this.loading = false;
          this.$root.$emit("submitStep");
        }, 1000);
      } catch (error) {
        const errorCode = error?.response?.data?.context?.code || "";

        switch (errorCode) {
          case "WAL_010012":
            //TODO: show modal not enough balance
            this.$root.$emit("openModal", "modalBalanceError");
            break;

          default:
            UtilityService.showDefaultError(error);
            break;
        }
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped></style>
